<script setup lang="ts">
import {useRoute} from "vue-router";
import {useHead} from "@unhead/vue";
import OrderModal from "~/components/modals/orderModal.vue";
import {authStore} from "~/stores/authStore";
import {basketStore} from "#imports";
import {computed} from "vue";
import Comments from "~/components/comment/comments.vue";

const {$api, $toast} = useNuxtApp()
const route = useRoute()
const auth = authStore()
const {headers} = storeToRefs(auth)
const game = await $api.get(`public/game?slug=${route.params.slug}`).then(res => res.data)
const products = await $api.get(`public/products?game=${game.id}&count=30`, headers.value).then(res => res.data)
const others = await $api.get(`public/category?slug=${game.category.slug}`).then(res => res.data)
const selectedProduct = ref(null)
const selectedQty = ref(1)
const basket = basketStore()
const {setBaskets} = basket
const selected = (product: any, qty: any) => {
  selectedProduct.value = product
  selectedQty.value = qty
}
const qty = ref([])
products.forEach(() => {
  return qty.value.push(1);
});
onMounted(() => {
  $('.single-sub-menu').click(function () {
    var getIcon = $(this).children('i').attr('class')
    if (getIcon === 'fal fa-angle-down') {
      $('.mobile-sub-menu').show(300)
      $(this).children('i').attr('class', 'fal fa-angle-up')
    } else {
      $('.mobile-sub-menu').hide(300)
      $(this).children('i').attr('class', 'fal fa-angle-down')
    }
  })
  $('.games-cart').click(function () {
    var atr = $(this).children('button').children('i').attr('class')
    var thiss = $(this).children('button')
    $(this).children('button').children('i').attr('class', 'fa fa-spinner fa-spin')
    $(this).children('button').attr('disabled', 'true')
    setTimeout(function () {
      $(thiss).children('i').attr('class', 'fal fa-shopping-bag')
      $(thiss).removeAttr('disabled')
      $('.toast').toast('show');
    }, 1000)
  })
})
const addBasket = (id: any, qty: any) => {
  $api.post('user/basket/add', {
    id,
    count: qty
  }, headers.value).then(res => {
    $api.get('user/basket', headers.value).then(res => {
      setBaskets(res.data)
    })
    $toast.success(res.data)
  }).catch(error => {
    $toast.error(error)
  })
}
useHead({
  title: `${game.name} satışı`,
  meta: [{
    name: 'description',
    content: game.meta_description
  }]
})
</script>

<template>
  <main>
    <!-- Mobile and PC title -->
    <div class="container back-orange manual">
      <div class="row">
        <div class="col-md-12">
          <div class="main-title">
            <h5> {{ game.name }} </h5>
            <div class="single-sub-menu">
              <i class="fal fa-angle-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile sub title -->
    <div class="container mobile-sub-menu">
      <div class="row reset-margin">
        <div class="col-md-12 mt-20">
          <div class="single-menu">
            <nuxt-link v-for="other in others.games" :to="{name: 'game-slug', params: {slug: other.slug}}"
                       exact-active-class="active-link" class="media">
              <img class="mr-3" :src="other.image" :alt="other.name">
              <div class="media-body">
                <h5 class="mt-0">{{ other.name }}</h5>
              </div>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile and PC contents -->
    <div class="container">
      <div class="row reset-margin">

        <!-- PC sub menus -->
        <div class="col-lg-3 mt-10 d-n-992">
          <div class="single-menu">
            <nuxt-link v-for="other in others.games" :to="{name: 'game-slug', params: {slug: other.slug}}"
                       exact-active-class="active-link" class="media">
              <img class="mr-3" :src="other.image" :alt="other.name">
              <div class="media-body">
                <h5 class="mt-0">{{ other.name }}</h5>
              </div>
            </nuxt-link>
          </div>
        </div>

        <!-- Mobile and PC tabs -->
        <div class="col-lg-9 mt-10">
          <div aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <nuxt-link to="/">Ana Səhifə</nuxt-link>
              </li>
              <li class="breadcrumb-item">
                <nuxt-link to="/games">Oyunlar</nuxt-link>
              </li>
              <li class="breadcrumb-item">
                <nuxt-link :to="{name: 'category-slug', params: {slug: game.category.slug}}">{{ game.category.name }}
                </nuxt-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">{{ game.name }}</li>
            </ol>
          </div>
          <div class="games-cover">
            <img :src="game.cover" :alt="game.name">
          </div>
          <div class="row">
            <div class="col-md-12 for-modal">

              <!-- PC and Mobile tabs title -->
              <ul class="nav nav-pills about-games" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <a class="nav-link active" id="mehsullar" data-toggle="pill" href="#tab_mehsullar"
                     role="tab"
                     aria-controls="mehsullar" aria-selected="true"><i class="fal fa-bars"></i>
                    <span>Məhsullar</span></a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="rules" data-toggle="pill" href="#tab_rules" role="tab"
                     aria-controls="rules" aria-selected="false"><i
                      class="fas fa-exclamation-circle"></i>
                    <span>Ətraflı</span></a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="using" data-toggle="pill" href="#tab_using" role="tab"
                     aria-controls="using" aria-selected="false"><i
                      class="fas fa-question-circle"></i> <span>İstifadə qaydası</span></a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="comments" href="#tab_comments" aria-selected="true"><i
                      class="fas fa-comment-lines"></i>
                    <span>Şərhlər</span></a>
                </li>
              </ul>

              <!-- PC and Mobile tabs content -->
              <div class="tab-content tab-products pt-0 all-inform only-single" id="pills-tabContent">
                <div class="tab-pane fade show active" id="tab_mehsullar" role="tabpanel"
                     aria-labelledby="mehsullar-tab">
                  <div class="row mr-0 ml-0">
                    <div v-for="(product, key) in (products)" class="col-md-12 m-manual" :data-id="product.id">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="d-flex mobile-single">
                            <div class="products-photo">
                              <nuxt-link class="d-block"
                                         :to="{name: 'game-product-slug', params: {slug: product.slug}}"><img
                                  :src="product.image"
                                  :alt="product.name"></nuxt-link>
                            </div>
                            <div class="products-more">
                              <nuxt-link class="white-anchor"
                                         :to="{name: 'game-product-slug', params: {slug: product.slug}}"><h1>
                                {{ product.name }}</h1></nuxt-link>
                              <span>{{ product.detail }}</span>
                              <div class="stocks">
                                <span>Stok</span>
                                <span>Bonus</span>
                              </div>
                              <div class="stocks">
                                <span v-if="product.stock > 0"><i class="far fa-check"></i></span>
                                <span v-else><i class="fal fa-times"></i></span>
                                <span><i class="fas fa-star"></i>
                                                                            <b
                                                                                class="point font-weight-lighter"> {{ product.bonus * qty[key] }}</b></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 position-relative right-single">
                          <div class="all-choose">
                            <div class="products-price">
                              <span v-if="product.old_price" class="old_price">{{(product.old_price).toFixed(2)}} Azn</span>
                              <span
                                  class="get_price">{{ (parseInt(qty[key]) * product.price).toFixed(2) }} Azn</span>
                            </div>
                            <div class="products-qty">
                              <input @click="() => {return qty[key] > 1 ? qty[key]-- : false}" type='button' value='-'
                                     class='qtyminus'
                                     field='quantity'/>
                              <input v-model="qty[key]" type='number' name='quantity'
                                     class='qty'/>
                              <input @click="qty[key]++" type='button' value='+' class='qtyplus'
                                     field='quantity'/>
                            </div>
                            <div class="theme-btn">
                              <a v-if="product.type === 'e-pin' && product.stock > 0"
                                 @click.prevent="addBasket(product.id, qty[key])"
                                 style="cursor: pointer; color: white">Səbətə at</a>
                              <div v-else>
                                <a v-if="product.stock" @click="selected(product, qty[key])"
                                   data-toggle="modal"
                                   data-target="#orderModal"
                                   style="cursor: pointer">Satın al</a>
                                <a v-else @click.prevent="() => false"
                                   data-toggle="modal"
                                   data-target="#orderModal"
                                   style="cursor: pointer; background: rgb(249 165 51 / 63%) !important">Satın al</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="tab_rules" role="tabpanel" aria-labelledby="rules-tab">
                  <div v-html="game.detail" class="games-warn">
                  </div>
                </div>
                <div class="tab-pane fade" id="tab_using" role="tabpanel" aria-labelledby="using-tab">
                  <div v-html="game.how" class="games-warn">
                  </div>
                </div>
              </div>
              <order-modal @incrementFromChildren="selectedQty++"
                           @decrementFromChildren="selectedQty > 1 ? selectedQty-- : false" :qty="selectedQty"
                           v-if="selectedProduct" :game="game" :product="selectedProduct"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <comments :game="game.id"/>
  </main>
</template>

<style scoped>

</style>